var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");
var resolve = require("./resolve");
var cookies = require("cookies-js");
var auth = require("../auth");

exports.getApp = function(id) {
  return request
    .get("/api/portal/app/" + id)
    .promise();
};

var oneHitLoginFunction = function (resolve, reject, username, password) {
  request.get("/login")
    .set("Accept", "json")
    .end(function (err, res) {
      var data = res.body;
      var oauthRequest = {
        client_id: data.client_id,
        redirect_uri: data.redirect_uri,
        state: data.state,
        scope: data.scope,
        username: username,
        password: password
      };
      request
        .post("/api/portal/login")
        .send(oauthRequest)
        .end(function (err, res) {
          if (!res.body) {
            resolve({ error: "Unknown Error" });
          } else if (res.body.error) {
            resolve({ error: res.body.error });
          } else {
            var redirect = res.body.redirect;
            request.get(redirect)
              .set("Accept", "json")
              .end(function (err, res) {
                var success = res.body.success;
                var cookie = cookies.get(window.conf.token_cookie_name);
                resolve({ success: success, token: res.body.token, redirect: res.body.redirect });
                auth.token = cookie;
                auth.refresh();
              });
          }
        });
    });
}

exports.oneHitLogin = function(username, password) {
  return new Promise(function (resolve, reject) {
    return oneHitLoginFunction(resolve, null, username, password);
  });
};
 
exports.oneHitRegister = function(email, firstName, lastName, password, gdprAnswers, token) {
  return new Promise(function(resolve, reject) {
    var user =
        {
          email: email,
          password: password,
          first_name: firstName,
          last_name: lastName,
          gdprAnswers: gdprAnswers,
          dologin: true,
          reCaptchaToken: token
        };
    request
        .post("/api/portal/signup", user)
        .end(function (err, res) {
          if (res.status != 200 && !res.body) {
            resolve({ error: "Unknown Error" });
          } else if (res.body && res.body.error) {
            resolve({ error: res.body.error });
          } else {
            oneHitLoginFunction(resolve, null, email, password);
          }
        });
  });
};

exports.login = function(stateParams, obj) {
  var opts = {
    client_id: stateParams.client_id,
    redirect_uri: stateParams.redirect_uri,
    state: stateParams.state,
    scope: stateParams.scope
  };
  if (obj.facebook) {
    opts.facebook = obj.facebook;
  } else {
    opts.username = obj.email;
    opts.password = obj.password;
  }

  return request
    .post("/api/portal/login")
    .send(opts)
    .promise();
};
exports.signup = function(user) {
  return request
    .post("/api/portal/signup", user)
    .promise();
};
exports.forgotPassword = function(obj) {
  obj.callbackUrl = resolve(config.baseUrl(), "/resetPassword");
  return request
    .post(resolve(config.url(), "/passwordResetTokens"), obj)
    .promise();
};
exports.confirmForgotPasswordToken = function(obj) {
  return request
    .post(resolve(config.url(), "/passwordResetTokens/" + obj.token + "/password"), obj)
    .promise();
};

exports.getLoginPageMessage = function() {
  return request
    .get(resolve(config.url(), "/tools/getloginpagemessage"))
    .promise();
};
